<template>
  <div class="cookies">
    <modal :active.sync="isActive" title="But first, Cookies.">
      <div class="is-flex content-center is-flex-column m-t-16 m-b-16 ">
        <img src="./../../assets/cookie.png" width="48" />
      </div>
      <p class="text">We use cookies to improve your experience and deliver personalized content.
        By using HireVibes, you agree to our <a href="https://docs.google.com/document/d/1jEZV1tOLG-59ZTKv5Z_-rF5thrl55Y4NzZJSj_NPR9s" target="_blank">Cookie Policy</a>.
      </p>
      <button class="button is-fullwidth is-primary" @click="close">
        Got it
      </button>
  </modal>
  </div>
</template>

<script>
import Modal from '@/components/dropdown-modal'

export default {
  components: { Modal },
  data () {
    return {
      isActive: !window.location.pathname.includes('/widget')
    }
  },
  methods: {
    close () {
      localStorage.setItem('cookies', true)
      this.isActive = false
    }
  },
  mounted () {
    if (localStorage.getItem('cookies') === 'true') {
      this.isActive = false
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/general/cookies.vue